import { AmuletAchievementState } from '@uniquegood/realworld-admin-interface';

export const AmuletActionLabel: Record<AmuletAchievementState, string> = {
  [AmuletAchievementState.UnAttainment]: '미달성',
  [AmuletAchievementState.Attainment]: '달성',
  [AmuletAchievementState.RewardRequest]: '보상 요청',
  [AmuletAchievementState.RewardComplete]: '보상 완료'
};
